import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { HttpModels } from '../../../../../models/api/http.models';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class FileApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'files');
  }

  getFileSasUrlByDownloadKey(downloadKey: string) {
    return this.getJson<HttpModels.BlobInfoResponse>('', {
      publicFileId: encodeURIComponent(downloadKey),
    });
  }

  downloadBlobFromStorageByFileId(id: number) {
    return this.getFileInformations(id).pipe(
      mergeMap((response) => {
        return this.getFileFromBlobStorage(response.blobReadOnlyPath!);
      }),
    );
  }

  getFileInformations(id: number): Observable<HttpModels.BlobInfoResponse> {
    return this.getJson<HttpModels.BlobInfoResponse>(`/${id}`);
  }

  getFileFromBlobStorage(
    blobUrl: string,
  ): Observable<HttpModels.HttpFileResponse> {
    return this.getDirectBlob(blobUrl, { withCredentials: false });
  }

  getFileAsBlob(url: string): Observable<HttpModels.HttpFileResponse> {
    return this.getBlob(url);
  }
}
